import React from "react";

const Monitoring = ({ width = "24", height = "24", color = "#141B34" }) => {
  return (
    <svg
      width={width + ""}
      height={height + ""}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5187_19933"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5187_19933)">
        <path
          d="M3.25 20.7497V19.1055L4.75 17.6055V20.7497H3.25ZM7.25 20.7497V15.1055L8.75 13.6055V20.7497H7.25ZM11.25 20.7497V13.6055L12.75 15.1305V20.7497H11.25ZM15.25 20.7497V15.1305L16.75 13.6305V20.7497H15.25ZM19.25 20.7497V11.1055L20.75 9.60547V20.7497H19.25ZM3.25 15.219V13.1055L10 6.35547L14 10.3555L20.75 3.60547V5.71897L14 12.469L10 8.46897L3.25 15.219Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Monitoring;
